var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Page"},[_c('div',{staticClass:"Page-content",class:_vm.contentClass},[_vm._t("default")],2),(_vm.$slots.actions)?_c('footer',{staticClass:"Page-actions",class:_vm.actionsClass},[_vm._t("actions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }